import React, { useEffect } from 'react';
import { useQuery } from 'react-query';

// eslint-disable-next-line import/order
import { getMiceActivityDonutChartData } from 'api/analitics/MCTCharts/3_getMiceActivityDonutChart';

// eslint-disable-next-line import/order
import { transformDataToPiePeriodChart } from 'utils/transformDataToPiePeriodChart';
import { TrapType } from 'components/AnalyticsPage/TrapType';

interface TableData {
  time_period: string[];
  count: number[];
}

export const useGetMiceActivityTableData = (
  slug: string,
  trapType: TrapType,
  startDate: string,
  endDate: string,
  enabled?: boolean,
) => {
  const { data, isLoading, isFetching, refetch } = useQuery(
    ['miceActivityTableData', slug, startDate, endDate],
    () => getMiceActivityDonutChartData(slug, trapType, startDate, endDate),
    {
      enabled,
      refetchOnWindowFocus: false,
    },
  );

  useEffect(() => {
    refetch();
  }, [slug, trapType, refetch]);

  // Transform data for table display
  const tableData: TableData = React.useMemo(() => {
    if (!data || !Array.isArray(data)) {
      return { time_period: [], count: [] };
    }

    // Transform raw data to period format
    const transformedData = transformDataToPiePeriodChart(data);

    // Sort by count descending
    const sortedData = transformedData.labels
      .map((label, index) => ({
        time_period: label,
        count: transformedData.series[index],
      }))
      .sort((a, b) => b.count - a.count);

    const time_period = sortedData.map(item => item.time_period);
    const count = sortedData.map(item => item.count);

    return { time_period, count };
  }, [data]);

  return {
    tableData,
    isLoading,
    isFetching,
    refetch,
  };
};

export default useGetMiceActivityTableData;
